module.exports = __webpack_public_path__ + "static/media/Alter-Password.82c071db.svg";